/* -------------------------------------------------------------------------- */
/*                                Dropdown styles                */
/* -------------------------------------------------------------------------- */

:host {
  @apply relative inline-block;
}
